export interface MissingPlayer {
  id: string;
  name: string;
  team: string;
  league: string;
  reason: string;
  expectedReturn: string;
  importance: "high" | "medium" | "low";
  position: string;
}

export const missingPlayers: MissingPlayer[] = [
  {
    id: "mp1",
    name: "엘링 홀란드",
    team: "맨체스터 시티",
    league: "프리미어리그",
    reason: "햄스트링 부상",
    expectedReturn: "2~3주",
    importance: "high",
    position: "ST",
  },
  {
    id: "mp2",
    name: "루이스 디아스",
    team: "리버풀",
    league: "프리미어리그",
    reason: "무릎 인대 부상",
    expectedReturn: "4~6주",
    importance: "high",
    position: "LW",
  },
  {
    id: "mp3",
    name: "부카요 사카",
    team: "아스널",
    league: "프리미어리그",
    reason: "발목 염좌",
    expectedReturn: "1~2주",
    importance: "high",
    position: "RW",
  },
  {
    id: "mp4",
    name: "로베르트 레반도프스키",
    team: "바르셀로나",
    league: "라리가",
    reason: "휴식 (로테이션)",
    expectedReturn: "다음 경기",
    importance: "high",
    position: "ST",
  },
  {
    id: "mp5",
    name: "주드 벨링엄",
    team: "레알 마드리드",
    league: "라리가",
    reason: "퇴장 징계",
    expectedReturn: "1경기",
    importance: "high",
    position: "CM",
  },
  {
    id: "mp6",
    name: "하리 케인",
    team: "바이에른 뮌헨",
    league: "분데스리가",
    reason: "무릎 통증",
    expectedReturn: "불명",
    importance: "high",
    position: "ST",
  },
  {
    id: "mp7",
    name: "이강인",
    team: "파리 생제르맹",
    league: "리그1",
    reason: "발목 부상",
    expectedReturn: "2주",
    importance: "medium",
    position: "AM",
  },
  {
    id: "mp8",
    name: "이정후",
    team: "샌프란시스코",
    league: "MLB",
    reason: "손가락 부상",
    expectedReturn: "3주",
    importance: "high",
    position: "OF",
  },
  {
    id: "mp9",
    name: "김하성",
    team: "샌디에이고",
    league: "MLB",
    reason: "장타상 부상",
    expectedReturn: "불명",
    importance: "high",
    position: "IF",
  },
  {
    id: "mp10",
    name: "류현진",
    team: "한화",
    league: "KBO",
    reason: "팔꿈치 통증",
    expectedReturn: "1주",
    importance: "high",
    position: "SP",
  },
  {
    id: "mp11",
    name: "양현종",
    team: "KIA",
    league: "KBO",
    reason: "병역 (훈련)",
    expectedReturn: "2주",
    importance: "high",
    position: "SP",
  },
  {
    id: "mp12",
    name: "박찬호",
    team: "피츠버그",
    league: "MLB",
    reason: "햄스트링 부상",
    expectedReturn: "4주",
    importance: "medium",
    position: "IF",
  },
  {
    id: "mp13",
    name: "최현준",
    team: "대한항공",
    league: "V리그",
    reason: "무릎 수술",
    expectedReturn: "6개월",
    importance: "high",
    position: "OP",
  },
  {
    id: "mp14",
    name: "허훈",
    team: "수원 KT",
    league: "KBL",
    reason: "코로나19",
    expectedReturn: "1주",
    importance: "medium",
    position: "G",
  },
  {
    id: "mp15",
    name: "Faker",
    team: "T1",
    league: "LCK",
    reason: "손목 통증",
    expectedReturn: "불명",
    importance: "high",
    position: "MID",
  },
];